import { defineStore } from 'pinia'
import { loadInsightsAPI } from '@/services/insights-service'
import { requestTypes } from '@/constants/request-types'

export const useInsightsStore = defineStore('insights-store', {
  state: () => ({
    error: {},
    loading: {},
    insightsTeam: {},
    insightsLeadership: {}
  }),
  actions: {
    clear() {
      this.error = {}
      this.loading = {}
      this.insightsTeam = {}
      this.insightsLeadership = {}
    },
    async loadInsightsAction({ groupName, surveyName = 'ALL', area }) {
      const areaName =
        area === 'team'
          ? requestTypes.INSIGHTS_TEAM
          : requestTypes.INSIGHTS_LEADERSHIP
      this.loading[areaName] = true
      try {
        this.error[areaName] = null
        const result = await loadInsightsAPI({
          groupName,
          surveyName,
          area
        })
        if (area === 'team') {
          this.insightsTeam = result
        } else {
          this.insightsLeadership = result
        }
      } catch (error) {
        this.error[areaName] = error
        throw error
      } finally {
        this.loading[areaName] = false
      }
    }
  }
})
